import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    heading: 'Your File Has Been Sent!',
    nextStepsDescription:
      'We will take care of your file and verify all supporting documents.\n\n We typically get back to you within 48 business hours.',
    nextStepsHeading: 'The Next Steps',
    nextStepsSubject: 'For You, {0}:',
    summary:
      'You will receive status notifications for your file at the following email address:',
    viewNextSteps: "See what's next",
  },
  fr: {
    heading: 'Votre dossier est envoyé !',
    nextStepsDescription:
      'Nous allons prendre en charge votre dossier et vérifier toutes les pièces justificatives.\n\n Nous revenons généralement vers vous dans les 48h ouvrées.',
    nextStepsHeading: 'Les prochaines étapes',
    nextStepsSubject: 'Pour vous, {0} :',
    summary: `Vous recevrez les notifications de suivi de votre dossier à l’adresse e-mail suivante :`,
    viewNextSteps: 'Voir les prochaines étapes',
  },
} as const);
